import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DiplomaResponse } from 'src/app/shared/models/diploma.model';
import { SnackBarService } from 'src/app/shared/services/snack-bar/snack-bar.service';
import { SessionStorageUtils } from 'src/app/shared/utils/session-storage';

@Component({
  selector: 'app-processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss']
})
export class ProcessingComponent implements OnInit { 

  constructor() { }

  ngOnInit(): void {
  }

}
